import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { AuthService } from '../../_services/auth.sevice';
import { CarrelloService } from '../../_services/carrello.service';
import { HeaderService } from '../../_services/header.service';
import { PreferitiService } from '../../_services/preferiti.service';

@Component({
  selector: 'app-sidebar-preferiti',
  templateUrl: './sidebar-preferiti.component.html',
  styles: []
})
export class SidebarPreferitiComponent implements OnInit, OnDestroy {

  constructor(
    private preferitiService: PreferitiService,
    private header: HeaderService,
    private carrelloService: CarrelloService,
    private auth: AuthService
  ) { }

  preferiti = [];

  subs: Subscription[] = [];

  isLoggedIn = this.auth.isLogged;

  ngOnInit() {
    if (this.isLoggedIn) {
      this.preferitiService.getPreferiti().subscribe(preferiti => {
        this.preferiti = preferiti;
      });

      this.subs.push(
        this.header.aggiornaPreferiti.subscribe(() => {
          this.preferitiService.getPreferiti().subscribe(preferiti => {
            this.preferiti = preferiti;
          });
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  rimuovi(preferito) {
    this.preferitiService.deletePreferito(preferito).subscribe();
  }

  aggiungiAlCarrello(preferito) {
    this.carrelloService.salvaProdotto({
      idScheda: preferito.idScheda,
      idPercorso: 0,
      quantita: 1
    }).subscribe();
  }

}
